module.exports={cookies:"Cookie",help:"ヘルプ",privacy:"プライバシー (更新済み)",signInWithId:"Adobe ID を使用してサインイン",termsOfUse:"利用条件"};